import { ItemMemberLevel, TeamMemberLevel, UserType } from "sprout-graphql";
import { useTopicPage } from "../TopicPageContext";
export default function useTopicAuthorization(topic) {
    const { isPartOfTopic , isOwnerOrAdmin , isOwner  } = useTopicPage();
    const { rootTopicOrSelf , deletedAt , archivedAt , isExplicitlyDeleted  } = topic;
    const { memberLevel , owner , special , membersCanInviteMembers  } = rootTopicOrSelf || {};
    const isSpecial = !!special;
    const isRootTopic = !!topic.isRootTopic;
    const isWorkspaceOwner = (owner === null || owner === void 0 ? void 0 : owner.type) === UserType.Team && owner.memberLevel === TeamMemberLevel.Owner;
    const trashOrArchived = deletedAt !== null || archivedAt !== null;
    return {
        editSection: !isRootTopic && isOwnerOrAdmin,
        editTopic: !isSpecial && isRootTopic && (isOwner || isWorkspaceOwner),
        // if you can edit topic, you can visit settings
        viewSettings: !isSpecial && isRootTopic && (isOwner || isWorkspaceOwner),
        editHideCompleted: isRootTopic && isOwnerOrAdmin,
        leave: !isSpecial && (memberLevel ? [
            ItemMemberLevel.Admin,
            ItemMemberLevel.Contributor
        ].includes(memberLevel) : false),
        move: !isRootTopic && isOwnerOrAdmin,
        addLeaf: isPartOfTopic && !trashOrArchived,
        addDivider: isPartOfTopic && !trashOrArchived,
        addDraftLeaf: isPartOfTopic && !trashOrArchived,
        addSection: isOwnerOrAdmin && !trashOrArchived,
        archive: isOwnerOrAdmin && !deletedAt,
        trash: isRootTopic && isOwner || !isRootTopic && isOwnerOrAdmin,
        delete: isExplicitlyDeleted && (isRootTopic && isOwner || !isRootTopic && isOwnerOrAdmin),
        star: !special && isRootTopic && isPartOfTopic,
        viewMembers: !isSpecial && isRootTopic,
        inviteTopicMembers: isOwnerOrAdmin || !!(memberLevel === ItemMemberLevel.Contributor && membersCanInviteMembers)
    };
};
